export type GetAccessToken = () => Promise<string>;
